import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCottage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#5C78C7"
      d="M2 14.502V8.98l-.725.567a.76.76 0 0 1-.566.142.72.72 0 0 1-.5-.292.74.74 0 0 1-.149-.56.72.72 0 0 1 .295-.503L2 7.083V5.25q0-.319.215-.534a.72.72 0 0 1 .531-.216q.317 0 .536.216a.72.72 0 0 1 .218.534v.688l3.587-2.744q.414-.32.918-.319.505 0 .917.318l6.731 5.14a.73.73 0 0 1 .285.5.77.77 0 0 1-.146.572.73.73 0 0 1-.498.283.75.75 0 0 1-.564-.146L14 8.979v5.523q0 .618-.44 1.058-.442.44-1.06.44H3.495q-.62 0-1.057-.44A1.45 1.45 0 0 1 2 14.502m1.5-.002h3.75v-2.25q0-.319.215-.534a.72.72 0 0 1 .531-.216q.317 0 .533.216a.73.73 0 0 1 .216.534v2.25H12.5V7.826L8 4.396 3.5 7.813zM2.917 3.542a.78.78 0 0 1-.678-.344.6.6 0 0 1-.03-.698q.292-.563.832-.896a2.2 2.2 0 0 1 1.189-.333.76.76 0 0 0 .688-.395.9.9 0 0 1 .28-.282.7.7 0 0 1 .387-.115q.438 0 .666.365.228.364 0 .719a2.45 2.45 0 0 1-.855.875q-.541.333-1.166.333a.745.745 0 0 0-.687.403.9.9 0 0 1-.272.264.66.66 0 0 1-.354.104"
    />
  </svg>
);
export default SvgCottage;
